import { DPI_DISPLAY, MM_PER_INCH } from './consts';

export const ptToMm = (pt: number) => (pt / DPI_DISPLAY) * MM_PER_INCH;
